<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-input v-model.trim="queryParam.corpBusinessName" placeholder=""/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="物料名称">
              <a-input v-model.trim="queryParam.materielName" placeholder=""/>
            </a-form-item>
          </a-col>

          <!-- <a-col :md="8" :sm="24">
            <a-form-item label="订单编号">
              <a-input v-model.trim="queryParam.order_orderNo" placeholder="请输入"/>
            </a-form-item>
          </a-col>-->

          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="操作"
      style="top: 10px;"
      :width="640"
      :confirmLoading="showLoading"
      v-model="visible"
      @ok="handleOk"
      destroyOnClose
    >
      <a-form :form="form">
        <a-form-item label="物料名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="物料名称"
            v-decorator="['order_materielId',
            { initialValue: mdl.order_materielId, rules: [{ required: true, message: '请选择物料名称'}]}]"
          >
            <a-select-option
              v-for="(item, index) in materielSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="客户名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            showSearch
            :filterOption="filterOption"
            placeholder="客户名称"
            v-decorator="['corpBusinessId',
            { initialValue: mdl.corpBusinessId, rules: [{ required: true, message: '请选择客户名称'}]}]"
          >
            <a-select-option
              v-for="(item, index) in businessSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="订单号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="订单号"
            v-model="mdl.order_orderNo"
            v-decorator="['order_orderNo', { initialValue: mdl.order_orderNo, rules: [{ required: true, message: '请输入订单号'}]}]"
          />
        </a-form-item>

        <a-form-item label="订单数量" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number :min="0" type="number" placeholder="订单数量" v-model="mdl.order_residueQuantity" />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { materielList, corpBusinessList, materielDelete, orderPage, orderSave, orderDelete } from '@/api/basic'
import moment from 'moment'
import { formatDate } from '../../utils/date.js'
import Bus from '@/layouts/bus'
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'OrderList',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      materielSelect: null,
      businessSelect: null,
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,

      // form: null,
      form: this.$form.createForm(this),
      mdl: {},
      disabled: true,

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},

      loading: false,
      showLoading: false,
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '40px'
        },
        {
          title: '物料名称',
          dataIndex: 'order_materielName',
          width: '220px'
        },
        {
          title: '客户名称',
          dataIndex: 'order_businessName',
          width: '220px'
        },

        {
          title: '订单号',
          dataIndex: 'order_orderNo',
          width: '220px'
        },
        {
          title: '订单量',
          dataIndex: 'order_residueQuantity',
          width: '220px'
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return orderPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },
      loadSelect() {
        // 从后台拉去下拉列表数据

        new Promise(resolve => {
          const data = materielList({}).then(res => {
            return res.data
          })
          resolve(data)
        }).then(res => {
          this.materielSelect = res
        }),
          new Promise(resolve => {
            const data = corpBusinessList({}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.businessSelect = res
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()

    // 初始化查询条件
    this.queryParam = this.queryParam || null
  },
  methods: {
    moment,
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
      this.disabled = true
    },
    handleAdd() {
      this.mdl = {}
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      this.visible = true
      this.disabled = false
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        if (!err) {
          this.showLoading = true
          orderSave(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(res => {
              this.showLoading = false
            })
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return orderDelete(Object.assign(record, nthis.queryParam))
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel() {}
      })
    },

    onChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  },
  watch: {}
}
</script>

<style scoped>
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>